import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import convertPost from '../../helpers/convertPost';
import { Dotdotdot, Composebox } from 'components';
import { populateComposebox } from 'redux/modules/composeboxForm';
import { removeQueueItem, updateQueue } from 'redux/modules/queues';
import { ModalLayout, Navbar } from 'containers';
import styles from './HorizontalPostCard.scss';

var getUrls = require('get-urls');

var HorizontalPostCard = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    favorites: state.contentLibrary.favorites && state.contentLibrary.favorites["".concat(orgId)] || [],
    organization: state.organization.current,
    theme: state.theme,
    contentChannelData: state.contentLibrary.contentChannelData,
    removingQueueItem: state.queues.removingQueueItem,
    selectedTimezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      utc_offset: {
        hours: new Date().getTimezoneOffset() / 60
      }
    }
  };
}, {
  populateComposebox: populateComposebox,
  removeQueueItem: removeQueueItem,
  updateQueue: updateQueue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(HorizontalPostCard, _Component);

  var _super = _createSuper(HorizontalPostCard);

  function HorizontalPostCard(props) {
    var _this;

    _classCallCheck(this, HorizontalPostCard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDeleteItem", function () {
      var _this$props$post = _this.props.post,
          OrganizationId = _this$props$post.OrganizationId,
          QueueId = _this$props$post.QueueId,
          id = _this$props$post.id;

      _this.props.removeQueueItem(OrganizationId, QueueId, id).then(function () {
        _this.setState({
          deleteDialogOpen: false
        });
      })["catch"](console.error);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditClick", function () {
      var fakeQueue = {
        type: _this.props.network
      };
      _this.props.post.Queue = fakeQueue;
      var translatedPost = convertPost(_this.props.post, false, _this.props.selectedTimezone);

      _this.props.populateComposebox(translatedPost, _this.props.organization.id);

      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/compose"),
        state: {
          modal: false
        }
      });
    });

    _this.state = {
      deleteDialogOpen: false
    };
    return _this;
  }

  _createClass(HorizontalPostCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var post = this.props.post;
      var tagNames = post.PostTemplate && post.PostTemplate.PostTemplateTagLegacyTags ? post.PostTemplate.PostTemplateTagLegacyTags.map(function (legTag) {
        return legTag.PostTemplateTag ? legTag.PostTemplateTag.tagName : null;
      }).filter(function (t) {
        return t;
      }) : [];
      var favoriteTagNames = this.props.favorites ? this.props.favorites.map(function (ftt) {
        return ftt.tagName;
      }) : [];

      var intersection = _.intersection(tagNames, favoriteTagNames);

      var category = intersection.length ? intersection[0] : tagNames[0];
      var imgUrl = post.S3Files && post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : null;
      var dialogButtons = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            deleteDialogOpen: false
          });
        },
        style: {
          marginRight: 24
        },
        disabled: this.props.removingQueueItem
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        onClick: this.handleDeleteItem,
        disabled: this.props.removingQueueItem,
        label: this.props.removingQueueItem ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Remove'
      })];
      var style = imgUrl ? {
        backgroundImage: "url(".concat(imgUrl, ")")
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        className: styles.postCard
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.imgPreview,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.imgPreviewOverlay
      }, category), !imgUrl && /*#__PURE__*/React.createElement("span", {
        className: styles.noImageCopy
      }, "No", /*#__PURE__*/React.createElement("br", null), "Image")), /*#__PURE__*/React.createElement("div", {
        className: styles.copy
      }, post.linkTitle && /*#__PURE__*/React.createElement(Dotdotdot, {
        clamp: 1
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.heading
      }, post.linkTitle)), /*#__PURE__*/React.createElement(Dotdotdot, {
        clamp: post.linkTitle ? 2 : 3
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.text
      }, this.props.post.message))), /*#__PURE__*/React.createElement("div", {
        className: styles.icons
      }, /*#__PURE__*/React.createElement("i", {
        className: "ion-edit",
        onClick: this.handleEditClick,
        style: {
          color: '#8b8b8b',
          fontSize: 16,
          paddingBottom: 10
        }
      }), /*#__PURE__*/React.createElement("i", {
        className: "ion-ios-trash-outline",
        onClick: function onClick() {
          return _this2.setState({
            deleteDialogOpen: true
          });
        },
        style: {
          fontSize: 22
        }
      })), /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.deleteDialogOpen,
        actions: dialogButtons,
        title: "Are you sure?"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1
        }
      }, "You are about to remove this item from your queue.")));
    }
  }]);

  return HorizontalPostCard;
}(Component)) || _class);
export { HorizontalPostCard as default };